import React, { HTMLAttributes } from 'react';
import { cx } from '@emotion/css';
import * as styles from './styles';

const FormGroup: React.FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => {
  return <div className={cx(styles.main, className)} {...rest} />;
};

export default FormGroup;
